import { lazy } from "react";
import { Navigate } from "react-router-dom";
import RouteGuard from "../routerPermission";

const ReturnDetail = lazy(
  () => import("@/widgets/return-management/ReturnDetail"),
);

const ReturnRoutes = {
  path: "returns",
  children: [
    {
      path: "",
      // The returns list now lives as a tab inside Order Management. Keep the
      // /returns URL working by redirecting to that tab; the detail route below
      // is unchanged.
      element: <Navigate to="../orders?tab=return" replace />,
    },
    {
      path: ":returnNumber",
      element: (
        <RouteGuard
          permissions={[
            { resource: "return", action: "read" },
            { resource: "order", action: "read" },
          ]}
        >
          <ReturnDetail />
        </RouteGuard>
      ),
    },
  ],
};

export default ReturnRoutes;
